<template>
  <div id="app"  @click="handleClick">
    <head-view ref="headViewRef" v-if="!isMbRoute()"/>
    <mobile-head-view v-if="isMbRoute()"/>
    <router-view />
    <foot-view v-if="!isMbRoute()"/>
    <mobile-foot-view v-if="isMbRoute()"/>
  </div>
</template>
<script>
import footView from "@/components/footView/footView.vue"
import headView from "@/components/headView/headView.vue"
import MobileHeadView from "@/components/headView/mobileHeadView";
import MobileFootView from "@/components/footView/mobileFootView";
export default {
  data() {
    return {

    };
  },
  mounted() {
    // 调用方法，打印匹配结果
    console.log("是否包含 'mb_':", this.isMbRoute());
  },
  components: {MobileFootView, MobileHeadView, footView, headView },
  methods:{
    isMbRoute() {
      // 获取当前路由路径
      const currentRoute = this.$route.path;
      console.log("当前路由路径:", currentRoute);

      // 正则匹配是否包含 "mb_"
      const regex = /mb_/;
      return regex.test(currentRoute);
    },
    handleClick(route) {
      const headViewElement = this.$refs.headViewRef.$el;
      if(!headViewElement.contains(event.target)){
        this.$refs.headViewRef.updateShow();
      }
    }
  }
};
</script>
